import { Textarea } from "@nextui-org/react";
import useAxios from "../../hooks/useAxios";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const Answer = () => {
    const [searchParams] = useSearchParams();
    const ticket = searchParams.get('ticket');

    const { AxiosPrivate } = useAxios()

    const [answer, setAnswer] = useState('')

    const handleSubmit = async () => {
        if (!answer.trim()) return
        else {
            await AxiosPrivate.put(`/ticket/reply/${ticket}`, { admin_reply: answer })
                .then(res => {
                    alert(res.data.message)
                })
                .catch(err => alert(err.response?.data.message))
        }
    }
    return (
        <>
            <div className="flex flex-col gap-2 mt-8">
                <div className="relative w-full">
                    <Textarea dir='rtl'
                        minRows={4}
                        maxRows={10}
                        labelPlacement="outside"
                        placeholder="جواب را اینجا وارد کنید"
                        value={answer}
                        onValueChange={setAnswer}
                    />
                    <span className="absolute -top-5 left-3">{answer?.length}</span>
                </div>
                <button onClick={handleSubmit} type="button" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 my-3 w-fit mr-auto">ثبت</button>
            </div>
        </>
    );
};

export default Answer;